import AccountFundings from './AccountFundings';

export default AccountFundings;
